import React from "react";
import { Check, ArrowRight, Star } from "lucide-react";
import { Button } from "@/components/ui/button";
import { motion } from "framer-motion";

const plans = [
{
  name: "Starter",
  price: "$35",
  period: "/month",
  description: "Perfect for small business websites",
  features: [
  "Monthly Bandwidth: up to 3GB",
  "Total File Storage: up to 3GB",
  "Managed Custom Hosting (WordPress, PHP, mySQL, etc)",
  "Nightly backups",
  "Security updates",
  "Support via Email",
  "Use of our licensed Plugins ($300+ annual savings)"],

  popular: false
},
{
  name: "Professional",
  price: "$65",
  period: "/month",
  description: "For growing businesses with more needs",
  features: [
  "Monthly Bandwidth: up to 10GB",
  "Total File Storage: up to 10GB",
  "Managed Custom Hosting (WordPress, PHP, mySQL, etc)",
  "Nightly backups",
  "Security updates",
  "Support via Email",
  "Use of our licensed Plugins ($300+ annual savings)"],

  popular: true
},
{
  name: "Business",
  price: "$85+",
  period: "/month",
  description: "Maximum performance for established sites",
  features: [
  "Monthly Bandwidth: up to 20GB",
  "Total File Storage: up to 20GB",
  "Managed Custom Hosting (WordPress, PHP, mySQL, etc)",
  "Nightly backups",
  "Security updates",
  "Priority Support via Email",
  "Use of our licensed Plugins ($300+ annual savings)"],

  popular: false
}];


export default function Pricing() {
  const handleScroll = (href) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="pricing" className="py-20 sm:py-28 bg-muted/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center mb-14 sm:mb-20">
          
          <p className="text-sm font-semibold uppercase tracking-widest text-primary mb-3">
            Pricing
          </p>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold tracking-tight mb-4">
            What will it cost?
          </h2>
          <p className="text-muted-foreground text-lg max-w-xl mx-auto">Hosting packages start at $35/month
5% discount if paid annually
          </p>
          <p className="text-sm text-muted-foreground mt-2 italic">
            * Ask about our pricing for non-profit organizations.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8 max-w-5xl mx-auto">
          {plans.map((plan, i) =>
          <motion.div
            key={plan.name}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: i * 0.1 }}
            className={`relative rounded-2xl p-8 sm:p-10 border transition-all duration-300 ${
            plan.popular ?
            "bg-primary text-primary-foreground border-primary shadow-xl shadow-primary/15 scale-[1.02]" :
            "bg-card border-border/50 hover:border-primary/20 hover:shadow-lg"}`
            }>
            
              {plan.popular &&
            <div className="absolute -top-3.5 left-1/2 -translate-x-1/2">
                  <span className="inline-flex items-center gap-1 px-4 py-1 rounded-full bg-accent text-accent-foreground text-xs font-bold uppercase tracking-wide">
                    <Star className="w-3 h-3" />
                    Most Popular
                  </span>
                </div>
            }
              <div className="mb-6">
                <h3
                className={`text-lg font-bold mb-1 ${
                plan.popular ? "text-primary-foreground" : ""}`
                }>
                
                  {plan.name}
                </h3>
                <p
                className={`text-sm ${
                plan.popular ?
                "text-primary-foreground/70" :
                "text-muted-foreground"}`
                }>
                
                  {plan.description}
                </p>
              </div>
              <div className="mb-8">
                <span
                className={`text-4xl sm:text-5xl font-bold ${
                plan.popular ? "text-primary-foreground" : ""}`
                }>
                
                  {plan.price}
                </span>
                <span
                className={`text-sm ${
                plan.popular ?
                "text-primary-foreground/70" :
                "text-muted-foreground"}`
                }>
                
                  {plan.period}
                </span>
              </div>
              <ul className="space-y-3 mb-8">
                {plan.features.map((feature) =>
              <li key={feature} className="flex items-start gap-3">
                    <Check
                  className={`w-4 h-4 mt-0.5 flex-shrink-0 ${
                  plan.popular ? "text-accent" : "text-accent"}`
                  } />
                
                    <span
                  className={`text-sm ${
                  plan.popular ?
                  "text-primary-foreground/90" :
                  "text-muted-foreground"}`
                  }>
                  
                      {feature}
                    </span>
                  </li>
              )}
              </ul>
              <Button
              onClick={() => handleScroll("#contact")}
              className={`w-full rounded-full py-6 font-semibold ${
              plan.popular ?
              "bg-white text-primary hover:bg-white/90" :
              "bg-primary hover:bg-primary/90 text-primary-foreground"}`
              }>
              
                Get Started
                <ArrowRight className="w-4 h-4 ml-2" />
              </Button>
            </motion.div>
          )}
        </div>

        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.3 }}
          className="text-center text-sm text-muted-foreground mt-8 italic">
          
          There are occasionally websites that will cost less per month.
        </motion.p>
      </div>
    </section>);

}